/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Welcome_Feature_Resume_DescInputs */

const en_onboarding_welcome_feature_resume_desc = /** @type {(inputs: Onboarding_Welcome_Feature_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatically adapt your resume to each job posting`)
};

const de_onboarding_welcome_feature_resume_desc = /** @type {(inputs: Onboarding_Welcome_Feature_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passe deinen Lebenslauf automatisch an jede Stellenausschreibung an`)
};

const fr_onboarding_welcome_feature_resume_desc = /** @type {(inputs: Onboarding_Welcome_Feature_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adapte automatiquement ton CV à chaque offre d'emploi`)
};

const es_onboarding_welcome_feature_resume_desc = /** @type {(inputs: Onboarding_Welcome_Feature_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adapte automáticamente su currículum a cada oferta de empleo`)
};

const it_onboarding_welcome_feature_resume_desc = /** @type {(inputs: Onboarding_Welcome_Feature_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adatta automaticamente il tuo curriculum a ogni offerta di lavoro`)
};

const nl_onboarding_welcome_feature_resume_desc = /** @type {(inputs: Onboarding_Welcome_Feature_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passeer automatisch je CV aan op elke vacature`)
};

const pl_onboarding_welcome_feature_resume_desc = /** @type {(inputs: Onboarding_Welcome_Feature_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatycznie dostosuj swoje CV do każdej oferty pracy`)
};

const fi_onboarding_welcome_feature_resume_desc = /** @type {(inputs: Onboarding_Welcome_Feature_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovita ansioluettelosi automaattisesti jokaiseen työpaikkaan`)
};

const da_onboarding_welcome_feature_resume_desc = /** @type {(inputs: Onboarding_Welcome_Feature_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilpas automatisk dit CV til hver jobannoncer`)
};

const sv_onboarding_welcome_feature_resume_desc = /** @type {(inputs: Onboarding_Welcome_Feature_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anpassa automatiskt ditt CV till varje jobbannons`)
};

/**
* | output |
* | --- |
* | "Automatically adapt your resume to each job posting" |
*
* @param {Onboarding_Welcome_Feature_Resume_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_welcome_feature_resume_desc = /** @type {((inputs?: Onboarding_Welcome_Feature_Resume_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Welcome_Feature_Resume_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_welcome_feature_resume_desc(inputs)
	if (locale === "fr") return fr_onboarding_welcome_feature_resume_desc(inputs)
	if (locale === "es") return es_onboarding_welcome_feature_resume_desc(inputs)
	if (locale === "it") return it_onboarding_welcome_feature_resume_desc(inputs)
	if (locale === "nl") return nl_onboarding_welcome_feature_resume_desc(inputs)
	if (locale === "pl") return pl_onboarding_welcome_feature_resume_desc(inputs)
	if (locale === "fi") return fi_onboarding_welcome_feature_resume_desc(inputs)
	if (locale === "da") return da_onboarding_welcome_feature_resume_desc(inputs)
	if (locale === "sv") return sv_onboarding_welcome_feature_resume_desc(inputs)
	return en_onboarding_welcome_feature_resume_desc(inputs)
});